import {TransformBase} from "../TranformBase";

import {AssistantSynthesizerCompactModel} from "@/api/models/assistants/synthesizers";
import {Assistant} from "@/api/services";

export class AssistantSynthesizersTransform extends TransformBase {
  // TODO(future): use function overloading for other DTO inputs.
  public makeCompactModel(dto: Assistant): AssistantSynthesizerCompactModel {
    const model: AssistantSynthesizerCompactModel = {
      filterWords: dto.synthesizer_filter_words,
      useFilterWords: dto.use_filler_words,
      optimizeStreamingLatency: dto.synthesizer_optimize_streaming_latency,
      similarityBoost: dto.synthesizer_similarity_boost,
      stability: dto.synthesizer_stability,
      style: dto.synthesizer_style,
      voicePrompt: (() => {
        const prompt = dto.synthesizer_voice_prompt || "";
        if (prompt.includes(" said ")) {
          const [pronoun, text] = prompt.split(" said ");
          return {
            pronoun: (pronoun as "he" | "she") || "he",
            text: text || "",
          };
        }
        return {
          pronoun: "he",
          text: prompt,
        };
      })(),
      speakerBoost: dto.synthesizer_use_speaker_boost,
    };

    return model;
  }
}

export const assistantSynthesizersTransform =
  new AssistantSynthesizersTransform();
